import { Spinner } from "@sfc/ui";
import { cn } from "@client/utils/cn";

/** Center within the content being replaced, never the whole browser viewport. */
export function AdminLoading({
  message = "Loading…",
  scope = "page",
}: {
  message?: string;
  scope?: "page" | "panel";
}) {
  return (
    <div
      role="status"
      aria-label={message}
      className={cn(
        "flex w-full items-center justify-center gap-3 text-muted-foreground",
        scope === "page" ? "py-12" : "py-6",
      )}
    >
      <Spinner
        className="size-5"
        role="presentation"
        aria-label={undefined}
        aria-hidden="true"
      />
      <span>{message}</span>
    </div>
  );
}
